import type { ServerToClientMessage } from '../types';
import { useIntegrityStore } from '../../stores/integrityStore';

export function dispatchIntegrityMessage(msg: ServerToClientMessage): boolean {
  switch (msg.type) {
    case 'integrity-update':
      useIntegrityStore.getState().setStatuses(msg.symbols);
      return true;
    case 'integrity-snapshot':
      useIntegrityStore.getState().replaceStatuses(msg.symbols);
      // Always replace alerts from the snapshot, including the empty case —
      // an empty array is a legitimate "no in-flight alerts" signal and must
      // clear stale UI state. Skipping the call left orphan alerts visible
      // after data-integrity restarts.
      if (msg.alerts !== undefined) {
        useIntegrityStore.getState().setAlerts(msg.alerts);
      }
      return true;
    case 'integrity-alert':
      useIntegrityStore.getState().addAlert(msg.alert);
      return true;
    case 'integrity-resolved':
      useIntegrityStore.getState().resolveAlert(msg.priorDigest);
      return true;
    case 'integrity-run':
      useIntegrityStore.getState().addRun(msg.run);
      return true;
    case 'integrity-runs-snapshot':
      useIntegrityStore.getState().setRuns(msg.runs);
      return true;
    case 'integrity-health':
      useIntegrityStore.getState().setHealth(msg.health);
      return true;
    case 'readiness-registry-update':
      useIntegrityStore.getState().upsertReadiness(msg.entry);
      return true;
    case 'readiness-registry-snapshot':
      useIntegrityStore.getState().replaceReadiness(msg.entries);
      return true;
    case 'incident-report':
      useIntegrityStore.getState().addIncident(msg.incident);
      return true;
    case 'incident-resolved':
      useIntegrityStore.getState().resolveIncident(msg.incidentId, msg.resolvedAt);
      return true;
    case 'incidents-snapshot':
      useIntegrityStore.getState().setIncidents(msg.incidents);
      return true;
    case 'freshness-snapshot':
      // Replace wholesale, including the empty-dark case — an empty set is
      // the all-clear and must clear the banner, the same lesson the
      // integrity-snapshot alerts branch above already learned.
      useIntegrityStore.getState().setFreshness(msg.freshness);
      return true;
    default:
      return false;
  }
}
